'use strict';

function isInvalidDate(value) {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime());
  }
  if (typeof value === "number") {
    return Number.isNaN(value);
  }
  return true;
}

exports.isInvalidDate = isInvalidDate;
//# sourceMappingURL=isInvalidDate.cjs.map
